import { render, staticRenderFns } from "./stock_ipo_hist_table.vue?vue&type=template&id=5c3d0189&scoped=true"
import script from "./stock_ipo_hist_table.vue?vue&type=script&lang=js"
export * from "./stock_ipo_hist_table.vue?vue&type=script&lang=js"
import style0 from "./stock_ipo_hist_table.vue?vue&type=style&index=0&id=5c3d0189&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d0189",
  null
  
)

export default component.exports